export default __webpack_public_path__ + "static/media/Target.196fca48ccfc221e31d1f28d3dd7a39a.svg";